import { ApiModel, ApiModelOptions } from "../../../ApiModel";
import { AddressModel } from "../../../models";
import { ModelScope } from "../../../types";
import { apiLocationModel } from "../useLocationModel";
import { checkUpdateAddress } from "./checkUpdateAddress";

export default function apiAddressModel(opts: ApiModelOptions<AddressModel>) {
  const model = ApiModel<AddressModel>("address", {
    urls: {
      [ModelScope.Mallcop]: {
        getOne: "/addresses/:id",
        getMany: "/addresses",
        create: "/addresses",
        update: "/addresses/:id",
        delete: "/addresses/:id",
      },
    },
    ...opts,
  });

  const saveAddressIfDifferent = async (
    newAddress?: AddressModel | null,
    oldAddress?: AddressModel | null,
  ): Promise<AddressModel | null> => {
    if (!newAddress) {
      return null;
    }

    const apiLocation = apiLocationModel({
      apiClient: opts.apiClient,
      placementsApiClient: opts.placementsApiClient,
    });

    if (!newAddress?.id) {
      let location;
      if (newAddress.location) {
        location = await apiLocation.create(newAddress.location);
      }
      return model.create({ ...newAddress, location: location });
    }

    if (checkUpdateAddress(oldAddress as AddressModel, newAddress)) {
      let location;
      if (newAddress.location) {
        location = await apiLocation.create(newAddress.location);
      }
      return model.create({
        ...newAddress,
        location: location,
        id: undefined,
      });
    }

    return newAddress;
  };

  return { ...model, saveAddressIfDifferent };
}
